import {PrInputGroup} from '../../interfaces/process-reports/pr-input-group';

export class PrInputGroupFactory {

  /**
   *
   * @param prInputGroup
   */
  public static fromObject(prInputGroup: any): PrInputGroup {
    return new class implements PrInputGroup {
      color: string = prInputGroup.color;
      created: string = prInputGroup.created;
      deleted: string = prInputGroup.deleted;
      id: number = prInputGroup.id;
      modified: string = prInputGroup.modified;
      name: string = prInputGroup.name;
      order: number = prInputGroup.order;
      prTypeId: number = prInputGroup.pr_type_id;
      size: number = prInputGroup.size;
      align: 'middle' | 'top' | 'bottom' = prInputGroup.align;
    };
  }

  /**
   *
   * @param prInputGroups
   */
  public static fromArray(prInputGroups: any[]): PrInputGroup[] {
    return prInputGroups.map(_prInputGroup => PrInputGroupFactory.fromObject(_prInputGroup));
  }

}
